"use client"

import { Text, Avatar } from "@/elements"
import clsx from "clsx"
import Link from "next/link"

interface Props {
  name: string | undefined | null
  avatarInitials?: string | undefined | null
  avatar80w: string | undefined | null
  subtext: string | undefined | null
  RightElement?: React.ReactElement<any>
  showSignUpOverlay?: boolean
  link: string | undefined | null
}

export const PersonalDetailCard: React.FC<Props> = ({
  name,
  avatarInitials,
  avatar80w,
  subtext,
  RightElement,
  link,
}) => {
  return (
    <Link href={!!link && link !== "undefined" ? link : "/"} className={clsx("w-full", !link ? "disabled" : "")}>
      <div className="relative w-full">
        <div className="flex w-full items-center rounded-full bg-bg-1">
          <div className="w-[40px] flex-shrink-0">
            <Avatar initials={avatarInitials} src={avatar80w ?? ""} size="sm" />
          </div>
          <div className="flex flex-1 flex-col overflow-hidden px-3">
            <Text maxLines={1}>{name}</Text>
            {subtext && (
              <Text className="text-fg-2" variant="caption" maxLines={1}>
                {subtext}
              </Text>
            )}
          </div>
          {RightElement && <div className="flex-shrink-0">{RightElement}</div>}
        </div>
      </div>
    </Link>
  )
}
